/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './PerformanceWarningMessage.scss';

import { connect } from 'react-redux';

import ModuleMessageBase from 'components/shared/ModuleMessageBase/ModuleMessageBase';
import { APP_LABEL, BROKERAGE_LABEL, RAS_LABEL } from 'services/Filters';
import {
  getShowActiveAdvisoryWarningForRateOfReturn,
  getShowActivePlusWarningForRateOfReturn,
  getShowAllPRRGraphWarningsForRateOfReturn
} from 'state/performance/RateOfReturnFilterSelectors';
import { hasBrokeragePerformanceOnly } from 'state/performance/PerformancePageSelectors';

class PerformanceWarningMessage extends ModuleMessageBase {
  constructor(props) {
    super(props, 'performance-warning', '', '');
  }

  shouldComponentUpdate(nextProps) {
    return this.props !== nextProps;
  }

  showMessage(props) {
    const {
      showBrokerageWarning,
      showActivePlusWarning,
      showActiveAdvisoryWarning,
      showAllPRRGraphWarnings,
      message
    } = props;

    return (
      message ||
      showBrokerageWarning ||
      showActivePlusWarning ||
      showActiveAdvisoryWarning ||
      showAllPRRGraphWarnings
    );
  }

  getTitle(props) {
    const {
      showBrokerageWarning,
      showActivePlusWarning,
      showActiveAdvisoryWarning,
      showAllPRRGraphWarnings,
      message
    } = props;
    const accounts = [];

    if (message) {
      return message;
    }
    if (showBrokerageWarning || showAllPRRGraphWarnings) {
      accounts.push(BROKERAGE_LABEL);
    }
    if (showActivePlusWarning || showAllPRRGraphWarnings) {
      accounts.push(APP_LABEL);
    }
    if (showAllPRRGraphWarnings) {
      accounts.push(RAS_LABEL);
    }
    if (showActiveAdvisoryWarning) {
      return `Personal Rate of Return is not available for clients who have access to multiple households. Please contact your advisor for any questions around Personal Rate of Return.`;
    }
    if (accounts.length === 0) {
      return '';
    }
    return `Personal Rate of Return not available for ${accounts.join(
      ' and '
    )} accounts.`;
  }
}

const mapStateToProps = (state) => {
  return {
    showBrokerageWarning: hasBrokeragePerformanceOnly(state),
    showActivePlusWarning: getShowActivePlusWarningForRateOfReturn(state),
    showActiveAdvisoryWarning:
      getShowActiveAdvisoryWarningForRateOfReturn(state),
    showAllPRRGraphWarnings: getShowAllPRRGraphWarningsForRateOfReturn(state)
  };
};

export default connect(mapStateToProps)(PerformanceWarningMessage);
